<template>
    <div class="message-item__content--file">
        <!-- video H5可播放的 -->
        <div v-if="fileIsVideo"
            class="file file__video"
            @click="play">
            <div class="file__icon">
                <icon
                    :name="icon"
                    type="png"
                    :width="72"
                    :height="68" />
            </div>
            <div class="file__info">
                <div class="file__name">{{fileName}}</div>
                <div class="file__param">
                    <div class="file__size">{{formatFileSize}}</div>
                    <div class="file__extension">{{extension}}</div>
                </div>
            </div>
        </div>
        <!-- not video -->
        <a v-else
            class="file"
            target="_blank"
            :href="url"
            @click.stop>
            <div class="file__icon">
                <icon
                    :name="icon"
                    type="png"
                    :width="72"
                    :height="68" />
            </div>
            <div class="file__info">
                <div class="file__name">{{fileName}}</div>
                <div class="file__param">
                    <div class="file__size">{{formatFileSize}}</div>
                    <div class="file__extension">{{extension}}</div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    import Icon from '@/components/Icon'
    import { getFileExtension, formatBytes } from '@/utils'

    const MimeType = require('mime-types')

    const DEFAULT_ICON = 'file'

    const ICON_SET = [
        {
            regex: /video/gi,
            icon: 'video'
        },
        {
            regex: /audio/gi,
            icon: 'audio'
        },
        {
            regex: /sheet|excel/gi,
            icon: 'excel'
        },
        {
            regex: /word/gi,
            icon: 'word'
        },
        {
            regex: /pdf/gi,
            icon: 'pdf'
        },
        {
            regex: /powerpoint|presentationml/gi,
            icon: 'ppt'
        }
    ]

    export default {
        name: 'MessageContentFile',
        components: {
            Icon
        },
        props: {
            fileName: {
                type: String,
                required: true
            },
            fileSize: {
                type: Number,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            url: {
                type: String,
                required: true
            }
        },
        computed: {
            extension () {
                return getFileExtension(this.fileName).toLowerCase() // 统一小写
            },
            icon () {
                // 客服端发送的文件的type为file,需要转换为文件对应的MIME类型
                // const mimeType = this.type === 'file' ? MimeType.lookup(this.extension) : this.type
                const mimeType = MimeType.lookup(this.extension)
                return this.getIconByType(mimeType)
            },
            formatFileSize () {
                return formatBytes(this.fileSize)
            },
            fileIsVideo () { // 是否是视频文件
                if (this.icon === 'video') {
                    // video标签仅支持三种格式
                    if (['mp4', 'ogg', 'webm'].includes(this.extension)) {
                        return true
                    }
                }
                return false
            }
        },
        methods: {
            getIconByType (type) {
                if (type) {
                    for (let i = ICON_SET.length - 1; i >= 0; i--) {
                        const item = ICON_SET[i]
                        if (type.match(item.regex)) {
                            return item.icon
                        }
                    }
                } 
                return DEFAULT_ICON
            },
            play () {
                if (this.url) {
                    this.$videoPlayer.setUrl({
                        url: this.url
                    })
                    this.$videoPlayer.show()
                    // $nextTick 避免获取不了 video 的 ref
                    this.$nextTick(() => {
                        this.$videoPlayer.play()
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .file {
        display: flex;
        justify-content: space-between;
        height: 68px;
        width: 254px;
        background-color: #fff;
        box-shadow: $primary-box-shadow;
        overflow: hidden;
        cursor: pointer;
        @include radius(1);

        @include desktop {
            width: 400px;
        }

        &__icon {
            flex-grow: 0;
            flex-shrink: 0;
        }

        &__info {
            flex-grow: 1;
            flex-shrink: 1;
            width: calc(100% - 72px);
            display: inline-flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 10px 15px;
        }

        &__name {
            font-size: 14px;
            color: $primary-text-color;
            line-height: 20px;
            @include text-line(1);
        }

        &__param {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #ABACAE;
            font-size: 12px;
            line-height: 16px;
        }

        @at-root .message-item--service & {
            @include radius(.25, .5, .5, .5);
        }

        @at-root .message-item--user & {
            @include radius(.5, .25, .5, .5);
        }
    }
</style>
